import {format, parseISO, subMonths} from 'date-fns';
import {ptBR} from 'date-fns/locale';
import {useEffect, useState} from 'react';

export const useConsultRefundDateFilter = (
	firstDate?: string,
	secondDate?: string,
	handleFilter?: (range: {dtFim: string; dtInicio: string}) => void,
) => {
	const [openDatePickerState, setOpenDatePickerState] = useState(false);
	const defaultInterval = {
		dtFim: format(new Date(), 'yyyy-MM-dd'),
		dtInicio: format(subMonths(new Date(), 3), 'yyyy-MM-dd'),
	};

	const currentInterval = {
		dtFim: secondDate || defaultInterval.dtFim,
		dtInicio: firstDate || defaultInterval.dtInicio,
	};

	const [dateInterval, setDateInterval] = useState(currentInterval);

	useEffect(() => {
		setDateInterval({
			dtFim: secondDate || defaultInterval.dtFim,
			dtInicio: firstDate || defaultInterval.dtInicio,
		});
	}, [firstDate, secondDate, defaultInterval.dtFim, defaultInterval.dtInicio]);

	const formatted = `De ${format(parseISO(dateInterval.dtInicio), 'dd/MM/yyyy', {locale: ptBR})} até ${format(parseISO(dateInterval.dtFim), 'dd/MM/yyyy', {locale: ptBR})}`;

	const handleResetDatePicker = () => {
		setOpenDatePickerState(false);
		setDateInterval(defaultInterval);
	};

	const handleClearDates = () => {
		handleResetDatePicker();
		handleFilter?.({
			dtFim: defaultInterval.dtFim,
			dtInicio: defaultInterval.dtInicio,
		});
	};

	return {
		defaultInterval,
		formatted,
		handleClearDates,
		handleResetDatePicker,
		openDatePickerState,
		setDateInterval,
		setOpenDatePickerState,
	};
};
